import SubscriptionAgreement from './SubscriptionAgreement'

export default SubscriptionAgreement
